export function isDeviceLocated(device) {
    return device.location !== undefined;
}
export function isDevicePaired(device) {
    return device.asset !== undefined;
}
/**
 * Checks if the given asset has a device,
 * and resolves it as a {@link PairedVelavuAsset}
 */
export function isAssetPaired(asset) {
    return asset.device_id !== undefined;
}
//# sourceMappingURL=device-utils.js.map